import React, { useState } from 'react';
import { ChevronDown, ChevronRight } from 'lucide-react';

const CollapsibleSection = ({ title, icon: Icon, children, defaultOpen = false, badge, badgeColor = 'stone' }) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  const colorClasses = {
    amber: 'bg-amber-100 text-amber-700',
    green: 'bg-green-100 text-green-700',
    violet: 'bg-violet-100 text-violet-700',
    stone: 'bg-stone-100 text-stone-600',
    blue: 'bg-blue-100 text-blue-700',
    red: 'bg-red-100 text-red-700',
  };
  return (
    <div className="border border-stone-200 rounded-xl overflow-hidden bg-white shadow-sm">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full flex items-center justify-between p-4 hover:bg-stone-50 transition-colors text-left">
        <div className="flex items-center gap-3">
          {Icon && <Icon className="h-5 w-5 text-stone-500" />}
          <span className="font-semibold text-stone-800">{title}</span>
          {badge && <span className={`text-xs px-2 py-0.5 rounded-full ${colorClasses[badgeColor] || colorClasses.stone}`}>{badge}</span>}
        </div>
        {isOpen ? <ChevronDown className="h-5 w-5 text-stone-400" /> : <ChevronRight className="h-5 w-5 text-stone-400" />}
      </button>
      {isOpen && <div className="px-4 pb-4 border-t border-stone-100">{children}</div>}
    </div>
  );
};

export default CollapsibleSection;
